import type { UtmValues } from '@/components/builder/UtmSection'
import type { TagEntry } from '@/lib/tagEntry'

const KEY_PREFIX = 'n3o:link-builder:state:v2:'

export interface PersistedState {
  baseUrl: string
  utm: UtmValues
  tags: TagEntry[]
}

function storageKey(subscriptionId: string): string {
  return `${KEY_PREFIX}${subscriptionId}`
}

function isPersistedState(value: unknown): value is PersistedState {
  if (value === null || typeof value !== 'object') return false
  const v = value as Record<string, unknown>
  if (typeof v.baseUrl !== 'string') return false
  if (v.utm === null || typeof v.utm !== 'object' || Array.isArray(v.utm)) return false
  if (!Array.isArray(v.tags)) return false
  return true
}

export function loadState(subscriptionId: string): PersistedState | null {
  try {
    const raw = localStorage.getItem(storageKey(subscriptionId))
    if (raw === null) return null
    const parsed: unknown = JSON.parse(raw)
    if (!isPersistedState(parsed)) return null
    return parsed
  } catch {
    return null
  }
}

export function saveState(subscriptionId: string, state: PersistedState): void {
  try {
    localStorage.setItem(storageKey(subscriptionId), JSON.stringify(state))
  } catch {
    /* quota exceeded, storage disabled, etc. — silently ignore */
  }
}
